import { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight, Rocket } from "lucide-react";
import { neon, useLaunch, Icon } from "./shared";

export function Showcase({ apps }) {
  const launch = useLaunch();
  const [i, setI] = useState(0);
  const [hold, setHold] = useState(false);
  const n = apps?.length || 0;
  useEffect(() => { if (!n || hold) return; const t = setInterval(() => setI((x) => (x + 1) % n), 4500); return () => clearInterval(t); }, [n, hold]);
  if (!n) return null;
  const visible = [0, 1, 2, 3].map((k) => apps[(i + k) % n]).slice(0, Math.min(4, n));
  return (
    <section onMouseEnter={() => setHold(true)} onMouseLeave={() => setHold(false)} data-testid="home-showcase">
      <div className="flex items-end justify-between mb-5">
        <div className="flex items-center gap-3"><Rocket className="w-7 h-7 text-cyan-300" /><div><h2 className="text-2xl md:text-3xl font-black">Featured Apps</h2><p className="text-sm text-white/60">Popular, trending and handpicked for you.</p></div></div>
        <div className="flex gap-2">
          <button onClick={() => setI((x) => (x - 1 + n) % n)} className="w-10 h-10 rounded-full bg-[#312e81] border border-cyan-400/40 grid place-items-center hover:bg-[#3730a3]" aria-label="Previous" data-testid="showcase-prev"><ChevronLeft /></button>
          <button onClick={() => setI((x) => (x + 1) % n)} className="w-10 h-10 rounded-full bg-[#312e81] border border-cyan-400/40 grid place-items-center hover:bg-[#3730a3]" aria-label="Next" data-testid="showcase-next"><ChevronRight /></button>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {visible.map((a, k) => (
          <div key={`${a.slug}-${i}`} className={`${neon} p-5 flex flex-col items-center text-center animate-in fade-in slide-in-from-right-4 duration-500 ${k > 0 ? "hidden sm:flex" : ""} ${k > 1 ? "sm:hidden lg:flex" : ""}`} data-testid={`showcase-card-${a.slug}`}>
            <Icon app={a} size="w-20 h-20" />
            <h3 className="font-black mt-3 truncate w-full">{a.name}</h3>
            <span className="text-[11px] mt-1 px-2.5 py-0.5 rounded-full bg-cyan-400/15 text-cyan-200 capitalize">{a.category}</span>
            <p className="text-xs text-white/65 mt-2 line-clamp-2 min-h-[2rem]">{a.tagline}</p>
            <button onClick={() => launch(a)} className="mt-4 w-full py-2.5 rounded-xl font-black bg-gradient-to-r from-cyan-400 via-sky-500 to-fuchsia-500 hover:brightness-110 active:scale-95 transition-transform" data-testid={`showcase-launch-${a.slug}`}>Launch</button>
          </div>
        ))}
      </div>
      <div className="flex justify-center gap-1.5 mt-4" data-testid="showcase-dots">{apps.map((a, k) => <button key={a.slug} onClick={() => setI(k)} aria-label={`Show ${a.name}`} className={`h-2 rounded-full transition-all ${k === i ? "w-6 bg-cyan-300" : "w-2 bg-white/25"}`} />)}</div>
    </section>
  );
}
